import { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useTranslation } from "react-i18next";

const LanguageDropdown = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "it", name: "Italiano", flag: "🇮🇹" },
  ];

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0]!;

  const changeLanguage = (langCode: string) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} className="d-inline-block">
      <DropdownToggle
        className="btn btn-topbar btn-ghost-secondary"
        tag="button"
        type="button"
        title={currentLanguage.name}
        style={{ minWidth: "auto", padding: "8px 12px" }}
      >
        <span className="fs-18 me-2">{currentLanguage.flag}</span>
        <span className="d-none d-md-inline">{currentLanguage.code.toUpperCase()}</span>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        {languages.map((lang) => (
          <DropdownItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={i18n.language === lang.code ? "active" : ""}
          >
            <span className="me-2">{lang.flag}</span>
            <span>{lang.name}</span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageDropdown;
